(() => {
  const roots = new WeakMap();
  const init = scope => scope.querySelectorAll('[data-yuxus-story]').forEach(root => {
    if (roots.has(root)) return;
    const abort = new AbortController();
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const cleanups = [];
    root.querySelectorAll('[data-yuxus-scenes]').forEach(scene => {
      const tabs = [...scene.querySelectorAll('[data-yuxus-tab]')];
      const panels = [...scene.querySelectorAll('[data-yuxus-panel]')];
      const frame = scene.querySelector('.y-scenes');
      let active = panels[0], timer;
      const updateHeight = () => { if (active) frame.style.height = `${active.getBoundingClientRect().height}px`; };
      const show = (key, animate = true) => {
        const next = panels.find(panel => panel.dataset.yuxusPanel === key);
        if (!next || (active === next && scene.hasAttribute('data-scenes-ready'))) return;
        if (animate) frame.style.height = `${frame.getBoundingClientRect().height}px`;
        panels.forEach(panel => {
          panel.hidden = panel !== next;
          panel.inert = panel !== next;
          if (panel !== next) panel.querySelectorAll('video').forEach(video => video.pause());
          panel.classList.remove('is-entering');
        });
        active = next;
        tabs.forEach(tab => { const selected = tab.dataset.yuxusTab === key; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
        if (animate && !motion.matches) next.classList.add('is-entering');
        requestAnimationFrame(updateHeight);
        clearTimeout(timer); timer = setTimeout(() => next.classList.remove('is-entering'), 450);
      };
      scene.querySelector('.y-tabs').addEventListener('click', event => { const tab = event.target.closest('[data-yuxus-tab]'); if (tab) show(tab.dataset.yuxusTab); }, {signal:abort.signal});
      scene.querySelector('.y-tabs').addEventListener('keydown', event => {
        if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key) || !tabs.includes(event.target)) return;
        event.preventDefault(); let i = tabs.indexOf(event.target);
        i = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[i].focus({preventScroll:true}); show(tabs[i].dataset.yuxusTab);
      }, {signal:abort.signal});
      show(tabs[0].dataset.yuxusTab, false); scene.setAttribute('data-scenes-ready','');
      const observer = new ResizeObserver(updateHeight); panels.forEach(panel => observer.observe(panel));
      cleanups.push(() => {observer.disconnect(); clearTimeout(timer);});
    });
    root.querySelectorAll('.y-geosort__visual').forEach(demo => {
      const select = demo.querySelector('[data-yuxus-market]');
      const grid = demo.querySelector('.y-merch-grid');
      if (!select || !grid) return;
      const cards = new Map([...grid.children].map(card => [card.dataset.yuxusProduct, card]));
      const orders = {es:[1,2,3,4,5,6],gb:[4,1,6,2,5,3],us:[2,5,4,6,3,1],de:[6,3,5,1,2,4]};
      const animations = new Set();
      const update = () => {
        const order = orders[select.value];
        if (!order) return;
        const positions = new Map([...cards.values()].map(card => [card, card.getBoundingClientRect()]));
        animations.forEach(animation => animation.cancel()); animations.clear();
        order.forEach(id => grid.appendChild(cards.get(String(id))));
        if (!motion.matches) order.forEach((id, i) => {
          const card = cards.get(String(id)), before = positions.get(card), after = card.getBoundingClientRect();
          const dx = before.left - after.left, dy = before.top - after.top;
          if ((!dx && !dy) || !card.animate) return;
          const animation = card.animate([{transform:`translate(${dx}px, ${dy}px)`,opacity:.7},{transform:'translate(0,0)',opacity:1}],{duration:560+i*22,easing:'cubic-bezier(.22,1,.36,1)'});
          animations.add(animation); animation.onfinish = () => animations.delete(animation);
        });
        const status = demo.querySelector('[data-yuxus-market-status]');
        if (status) status.textContent = `${status.dataset.message} ${select.selectedOptions[0].textContent.trim()}`;
      };
      select.addEventListener('change', update, {signal:abort.signal});
      cleanups.push(() => {animations.forEach(animation => animation.cancel()); animations.clear();});
    });
    if ('IntersectionObserver' in window && !motion.matches) {
      const reveals = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveals.unobserve(entry.target); }
      }), {threshold:.18});
      root.querySelectorAll('[data-yuxus-reveal]').forEach(element => { element.setAttribute('data-reveal-ready',''); reveals.observe(element); });
      cleanups.push(() => reveals.disconnect());
    }
    roots.set(root, () => {abort.abort(); cleanups.forEach(cleanup => cleanup());});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-yuxus-story]').forEach(root => {roots.get(root)?.(); roots.delete(root);}));
})();
